import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CampanhaService {
  public params = new HttpParams();

  constructor(private readonly apiService: ApiService) {}

  private cleanHtmlEntities(obj: any): any {
    if (obj === null || obj === undefined) {
      return obj;
    }
    if (typeof obj === 'string') {
      return obj.replace(/&nbsp;/g, ' ');
    }
    if (Array.isArray(obj)) {
      return obj.map((item) => this.cleanHtmlEntities(item));
    }
    if (typeof obj === 'object') {
      const cleaned: any = {};
      for (const key of Object.keys(obj)) {
        cleaned[key] = this.cleanHtmlEntities(obj[key]);
      }
      return cleaned;
    }
    return obj;
  }

  list(params?: any): Observable<any> {
    return this.apiService
      .get(
        `/Campanha`,
        params
          ? new HttpParams({
              fromObject: params,
            })
          : this.params,
      )
      .pipe(map((response) => this.cleanHtmlEntities(response)));
  }

  listPublic(params?: any): Observable<any> {
    return this.apiService
      .get(
        `/Campanha/Dominio`,
        params
          ? new HttpParams({
              fromObject: params,
            })
          : this.params,
      )
      .pipe(map((response) => this.cleanHtmlEntities(response)));
  }

  show(id: string, params?: any): Observable<any> {
    let httpParams: HttpParams | undefined;
    if (params) {
      const cleanParams: any = {};
      Object.keys(params).forEach((key) => {
        const val = params[key];
        if (val !== undefined && val !== null && val !== '') {
          cleanParams[key] = val;
        }
      });
      if (Object.keys(cleanParams).length > 0) {
        httpParams = new HttpParams({ fromObject: cleanParams });
      }
    }

    return this.apiService
      .get(`/Campanha/${id}`, httpParams || this.params)
      .pipe(map((response) => this.cleanHtmlEntities(response)));
  }

  // get photo Empresa do sector
  getPhotoCampanhaByID(id: number): Observable<Blob> {
    return this.apiService.get(`/Anexo/Ficheiro/${id}`, undefined, 'blob');
  }

  /**
   * Cria uma nova Campanha
   * @param formData FormData contendo os dados da Campanha
   * @returns Observable<any>
   */
  public store(formData: FormData): Observable<any> {
    return this.apiService.post(`/Campanha`, formData);
  }

  /**
   * Cria uma nova Campanha
   * @param formData FormData contendo os dados da Campanha
   * @returns Observable<any>
   */
  public update(formData: FormData): Observable<any> {
    return this.apiService.put(`/Campanha`, formData);
  }

  rejeit(id: string, motivo: string): Observable<any> {
    return this.apiService
      .put(`/Campanha/EstadoRecusar/${id}/${motivo}`)
      .pipe(map((response) => response));
  }

  delete(id: string): Observable<any> {
    return this.apiService
      .delete(`/Campanha/${id}`)
      .pipe(map((response) => response));
  }

  updateStatus(id: string, estadoCampanhaEnum: string): Observable<any> {
    return this.apiService
      .put(`/Campanha/Estado/${id}/${estadoCampanhaEnum}`)
      .pipe(map((response) => response));
  }

  extend(params: {
    campanhaID: number;
    motivo: string;
    dias: number;
  }): Observable<any> {
    return this.apiService.put(`/Campanha/SolicitarProrrogar`, params);
  }

  suspender(params?: any): Observable<any> {
    return this.apiService.put(`/Campanha/CampanhaEstadoMotivo`, params);
  }

  aprovarProrrogacao(campanhaID: number): Observable<any> {
    return this.apiService
      .put(`/Campanha/AprovarProrrogar/${campanhaID}`)
      .pipe(map((response) => response));
  }

  reembolsarApoios(id: string): Observable<any> {
    return this.apiService.put(`/Campanha/Reembolso/${id}`);
  }

  carregarAnexoBackOffice(formData: FormData): Observable<void> {
    return this.apiService.post(`/Campanha/CarregarAnexoBackOffice`, formData);
  }
}
